import Token from '@web/common/token'
import { useStore } from '@web/store'
import { User } from '@web/store/types/modules/user'
import urlParse from 'url-parse'
import { useRouter } from 'vue-router'

import { useOnboardingResolver } from '@web/platform.v3/onboardings/useOnboardingResolver'

export function useRedirectAfterLogin () {
  const router = useRouter()
  const store = useStore()
  const { goAfterLogin } = useOnboardingResolver()

  async function redirectAfterLogin (user?: User): Promise<void> {
    if (user && (user.requirePhoneValidate || user.requiredUpdateProfile)) {
      goAfterLogin()
      return
    }

    const returnUrlFromQuery = router.currentRoute.value.query.returnUrl as string | null
    const returnUrlFromStore: string = store.state.main.returnUrl

    function openExternal (url: string): void {
      const URLParseInstance = urlParse(url, true)
      URLParseInstance.set('query', {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ...URLParseInstance.query,
        token: Token.get()
      })
      window.location.href = URLParseInstance.toString()
    }

    if (returnUrlFromQuery) {
      openExternal(returnUrlFromQuery)
    } else if (/^https?:\/\//.test(returnUrlFromStore)) {
      openExternal(returnUrlFromStore)
    } else if (returnUrlFromStore && returnUrlFromStore !== '/') {
      router.push(returnUrlFromStore)
    } else {
      goAfterLogin()
    }
  }

  return { redirectAfterLogin }
}

export default useRedirectAfterLogin
